import { render } from "./radio-open-close.vue?vue&type=template&id=67bf6d70"
import script from "./radio-open-close.vue?vue&type=script&lang=js"
export * from "./radio-open-close.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__